import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api, setUnauthorizedHandler } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    setUnauthorizedHandler(() => setUser(false));
    // Returning from Google: AuthCallback exchanges the session_id first
    if (window.location.hash.includes("session_id=")) {
      return;
    }
    api
      .me()
      .then(setUser)
      .catch(() => api.refresh().then(setUser).catch(() => setUser(false)));
  }, []);

  const login = useCallback(async (email, password, remember = true) => setUser(await api.login({ email, password, remember })), []);
  const loginWithGoogle = useCallback(async (sessionId) => setUser(await api.googleLogin(sessionId)), []);
  const logout = useCallback(async () => {
    await api.logout().catch(() => {});
    setUser(false);
  }, []);

  const value = useMemo(() => ({ user, setUser, login, loginWithGoogle, logout }), [user, login, loginWithGoogle, logout]);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
